import { pages } from "./lazyPages";

const { home, menu, offers, checkout, orderConfirmation, giftcardPurchase } =
  pages;

export const publicRoutes = [
  { path: "/", element: <home.Component /> },
  { path: "/home", element: <home.Component /> },
  { path: "/menu", element: <menu.Component /> },
  { path: "/giftcard/purchase", element: <giftcardPurchase.Component /> },
  { path: "/menu/:categoryId", element: <menu.Component /> },
  { path: "/menu/:categoryId/:productId", element: <menu.Component /> },
  { path: "/offer-and-rewards", element: <offers.Component /> },
  { path: "/checkout", element: <checkout.Component /> },
  { path: "/orders/:orderId", element: <orderConfirmation.Component /> },
  {
    path: "/order-complete/:orderId",
    element: <orderConfirmation.Component />,
  },
];
